
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Function to scroll to top of page
export function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

// ULTRA DIRECT pricing page navigation that bypasses all routing
export function goToPricingPage(source: string = 'direct') {
  console.log('🟢 ULTRA DIRECT PRICING: Called from', source);
  
  // Create a timestamp to prevent caching
  const timestamp = Date.now();
  
  // Construct absolute URL
  const absoluteUrl = `${window.location.origin}/pricing?source=${source}&t=${timestamp}`;
  
  // Use replace to completely bypass history
  window.location.replace(absoluteUrl);
  
  // If somehow that fails, try alternative approaches
  setTimeout(() => {
    if (window.location.pathname !== '/pricing') {
      console.log('🟢 ULTRA FALLBACK: First attempt failed, trying href');
      window.location.href = absoluteUrl;
    }
  }, 100);
}
